export const cleanTicks = (str: string): string => str.split("'").join('');
